<template>
  <g fill="none">
    <path
      d="M2 9L7 14L12 10.5L17 11.5L22 4"
      stroke="#F39C12"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 20L7 18L11.5 13.5L15.5 15.5L19.5 15L22 12"
      stroke="#1E88E5"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 6L7 4L12 7L17 3L22 7"
      stroke="#0E8A1A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>
